
import React from 'react';
import { Check, X } from 'lucide-react';

interface PasswordCriteria {
  hasLowercase: boolean;
  hasUppercase: boolean;
  hasNumber: boolean;
  hasSpecial: boolean;
  isLongEnough: boolean;
}

interface PasswordCriteriaListProps {
  criteria: PasswordCriteria;
}

export const PasswordCriteriaList: React.FC<PasswordCriteriaListProps> = ({ criteria }) => {
  const criteriaList = [
    { key: 'isLongEnough', met: criteria.isLongEnough, text: 'Pelo menos 8 caracteres' },
    { key: 'hasLowercase', met: criteria.hasLowercase, text: 'Pelo menos uma letra minúscula (a-z)' },
    { key: 'hasUppercase', met: criteria.hasUppercase, text: 'Pelo menos uma letra maiúscula (A-Z)' },
    { key: 'hasNumber', met: criteria.hasNumber, text: 'Pelo menos um número (0-9)' },
    { key: 'hasSpecial', met: criteria.hasSpecial, text: 'Pelo menos um caractere especial (!@#$%...)' }
  ];

  return (
    <div className="mt-3 space-y-2">
      <p className="text-xs text-white/70 mb-2">Sua senha deve conter:</p>
      <div className="space-y-1">
        {criteriaList.map((criterion) => (
          <div key={criterion.key} className="flex items-center gap-2">
            {criterion.met ? (
              <Check className="h-3 w-3 text-green-400 flex-shrink-0" />
            ) : (
              <X className="h-3 w-3 text-red-400 flex-shrink-0" />
            )}
            <span className={`text-xs ${criterion.met ? 'text-green-400' : 'text-red-400'}`}>
              {criterion.text}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PasswordCriteriaList;
